import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/app.service";


@Component({
  selector: 'app-physics-lab',
  templateUrl: './physics-lab.component.html',
  styleUrls: ['./physics-lab.component.scss']
})
export class PhysicsLabComponent implements OnInit {   
  Physics_lab: any[] = [];
  Multimedia_classroom_data: any;
  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.FetchData();
  }

  FetchData() {
    this.appService.getContents().subscribe((response: any) => {
      console.log(response, "Multimedia API Response");

      if (response?.data) {
        // Filter for Multimedia category
        this.Physics_lab= response.data.filter(
          (x: any) => x.ContentCategoryName === "Physics Lab"
        );
        console.log(this.Physics_lab, "Filtered Physics Data");
      }
    });
  }
}
